import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My first Pecha Kucha talk",
  "description": "",
  "published": "2012-07-25T00:00:00.000Z",
  "redirect_from": ["/blog/my-first-pecha-kucha-talk/swizec/4901"],
  "categories": "Ignite, Pecha Kucha, Presenter, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few weeks ago I delivered my first ever `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Pecha_Kucha",
        "title": "Pecha Kucha"
      }}>{`Pecha Kucha`}</a>{` talk.`}</p>
    <p>{`Pecha Kucha works a little bit like `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Ignite_%28event%29",
        "title": "Ignite (event)"
      }}>{`Ignite`}</a>{` with a few tweaks. You have to give a short talk consisting of 20 slides, where every slide automatically changes to the next one every 20 seconds. This gives you a talk that is 400 seconds or 6 minutes 40 long.`}</p>
    <p>{`With Ignite it's 20 slides and every 15 seconds. Not much of a difference but very important.`}</p>
    <p>{`Talking for 15 seconds is easy, you don't even have to know what you'll be talking about and can just look at the topic given on your slide and start. But with 20 seconds you have to think a little bit aobut what you're going to say, if you wing it completely you will have dead air, but if you prepare a bit too much you will run out of time on every slide.`}</p>
    <p>{`And it's impossible to catch up to a Pecha Kucha presentation, they're just too quick.`}</p>
    <p>{`I spent a lot of time preparing for my talk, but not that much time practicing and it shows in the video. Sometimes I have to make a comical gesture because the slide doesn't change quickly enough and other times I kind of get run-over by the next topic at hand - this happens when you're very used to changing slides at uneven intervals.`}</p>
    <p>{`Another thing the video shows is that I had too much content prepared for too little time. The BPM of my talking speed is insane and really dilutes my message ... well the fact there are too many messages already dilutes my message.`}</p>
    <p>{`To top it all off I was actually quite nervous because I didn't know if I matched my presentation well to the audience (always do research on who your audience is) and because the format was new and I knew I didn't prepare well enough.`}</p>
    <p>{`But hey, apparently I'm doing another thing similar to this in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=44.8205555556,20.4622222222&spn=0.1,0.1&q=44.8205555556,20.4622222222%20(Belgrade)&t=h",
        "title": "Belgrade"
      }}>{`Belgrade`}</a>{` on the 31st of August. That should be fun.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.designsojourn.com/presentation-skills-i-learnt-from-pecha-kucha/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_05_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.designsojourn.com/presentation-skills-i-learnt-from-pecha-kucha/"
        }}>{`Presentation Skills I Learnt From Pecha Kucha`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://managebetternow.com/2012/05/17/yes-pecha-kucha-can-make-you-a-better-presenter/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/89347850_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://managebetternow.com/2012/05/17/yes-pecha-kucha-can-make-you-a-better-presenter/"
        }}>{`Yes, Pecha Kucha Can Make You A Better Presenter`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.psfk.com/2012/07/pecha-kucha-design-inspiration-21.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_02_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.psfk.com/2012/07/pecha-kucha-design-inspiration-21.html"
        }}>{`Urban Exploring In Kyiv & A Look Inside A Dog's Life `}{`[`}{`PechaKucha`}{`]`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://marlyb.wordpress.com/2012/06/01/a-speedy-intro-to-pecha-kucha/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/91959095_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://marlyb.wordpress.com/2012/06/01/a-speedy-intro-to-pecha-kucha/"
        }}>{`A speedy intro to Pecha Kucha`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.psfk.com/2012/07/pecha-kucha-design-inspiration-19.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/102167595_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.psfk.com/2012/07/pecha-kucha-design-inspiration-19.html"
        }}>{`A Plush Traveling Companion & The Indonesian Youth Conference `}{`[`}{`PechaKucha`}{`]`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=c5d5b794-85a9-4b1e-93f8-12a22bd11ea4",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      